import { render, staticRenderFns } from "./TheLogin.vue?vue&type=template&id=fb2fa7b8&"
import script from "./TheLogin.vue?vue&type=script&lang=ts&"
export * from "./TheLogin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports